require('./distributionKeys.less');

class DistributionKeysController {
    distributionKeys;
    newDistributionKey;
    
    deleteIcon = {
        name:'delete',
        tooltip:'Slett fordelingsnøkkel',
        functionCall:(event,user)=> this.deleteDistributionKey(event, user)
    };

    tableDefinition = {
        settings: {title: "Fordelingsnøkler", editFunction: (event, distKey)=> this.editDistributionKey(event, distKey), promise: null},
        columns:[
            {title:'', name: 'active', type:'boolean', cellClass:'width-of-bool-cell'},
            {title:'Navn', name: 'name'},
            {title:'Jan', name:'january', type:'number'},
            {title:'Feb', name:'february', type:'number'},
            {title:'Mar', name:'march', type:'number'},
            {title:'Apr', name:'april', type:'number'},
            {title:'Mai', name:'may', type:'number'},
            {title:'Jun', name:'june', type:'number'},
            {title:'Jul', name:'july', type:'number'},
            {title:'Aug', name:'august', type:'number'},
            {title:'Sep', name:'september', type:'number'},
            {title:'Okt', name:'october', type:'number'},
            {title:'Nov', name:'november', type:'number'},
            {title:'Des', name:'december', type:'number'},
            {title: "", icon: this.deleteIcon, cellClass:'width-of-delete-cell'}
        ]
    };

    toolbarHeaderDefinitionNewDistributionKey = {
        isTable: true,
        toolbarHeading: "Ny fordelingsnøkkel"
    };

    constructor(private toastService, private DistributionKeys, private $filter, private $mdDialog){
    }

    $onInit() {
        this.getDistributionKeys();
    }

    getDistributionKeys () {
        this.tableDefinition.settings.promise = this.DistributionKeys.getDistributionKeys().$promise.then(
            (result) => {
                this.distributionKeys = result;
            }, (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    reportPercent = function() {
        var percVal = 0;
        this.newDistributionKey.months.forEach(function(month){
          if(month.val){
              percVal += month.val;
          }
        });
        this.newDistributionKey.totalVal = percVal;
    };

    addDistributionKey (ev) {
        this.$mdDialog.show({
            template: '<distribution-key-details-dialog></distribution-key-details-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false
        }).then((msg) => {
            if(msg === 'success'){
                this.getDistributionKeys();
            }
        });
    };

    editDistributionKey (ev, distKey){
        this.$mdDialog.show({
            template: '<distribution-key-details-dialog active-key-for-edit="c.activeKeyForEdit"></distribution-key-details-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeKeyForEdit = distKey;
            }],
        }).then((msg) => {
            if(msg === 'success'){
                this.getDistributionKeys();
            }
        });
    };

    deleteDistributionKey (ev, distKey) {
        ev.stopPropagation();
        this.DistributionKeys.deleteDistributionKey({val: distKey.id}).$promise.then(
        () => {
            this.getDistributionKeys();
        }, (error) => this.toastService.parseError(error));
    }
}

class DistributionKeysOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcDistributionKeysController";
    public template: any = require('./distributionKeys.html');
}

rkcApp.controller("rkcDistributionKeysController", ['toastService', 'DistributionKeys', '$filter', '$mdDialog', function( toastService, DistributionKeys, $filter, $mdDialog){
    return new DistributionKeysController(toastService, DistributionKeys, $filter, $mdDialog);
}])
    .component("rkcDistributionKeys", new DistributionKeysOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distributionKeys/distributionKeys.ts
 **/